const handleInputChange = (setFormData) => (id, value) => {
  setFormData((prevData) => ({
    ...prevData,
    [id]: value,
  }));
};
export default handleInputChange;
